import { render, staticRenderFns } from "./DescStatisticsResult.vue?vue&type=template&id=8fa6388a&scoped=true&"
import script from "./DescStatisticsResult.vue?vue&type=script&lang=js&"
export * from "./DescStatisticsResult.vue?vue&type=script&lang=js&"
import style0 from "./DescStatisticsResult.vue?vue&type=style&index=0&id=8fa6388a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa6388a",
  null
  
)

export default component.exports